import React, { PropsWithChildren, useEffect, useState } from 'react';
import { MappedComponentProperties } from '@adobe/aem-react-editable-components';
import { useWidthContext } from '../../providers/Width';
import { transformHTMLParserLinks } from '../../utils/rewriteLink/rewriteLink';
import './Button.css';
import { ButtonWrapper, LinkWrapper } from '../LinkWrapper/LinkWrapper';
import { retrieveDBOsgiUrl } from '../../utils/cob-utils';
import { Row, Col, Modal, Container, Video } from '../../importCL';
interface ICTATextProps extends MappedComponentProperties {
    ctaType?: 'ghosted-light' | 'ghosted-dark' | 'link' | 'chip' | 'solid';
    ctaSize?: 'small' | 'medium' | 'large';
    ctaIcon?: 'lock' | 'chevron' | 'back' | '';
    variant?: string;
    text?: string;
    cta?: string;
    ctaId?: string;
    link?: string;
    videoLink?: string;
    leftJustified?: boolean;
    centerJustified?: boolean;
    linkOpenNewTab?: boolean;
    hiddenOnMobile?: boolean;
    hiddenOnDesktop?: boolean;
    backgroundColor?: string;
    paddingDesktopTop?: string;
    paddingDesktopBottom?: string;
    paddingDesktopLeft?: string;
    paddingDesktopRight?: string;
    paddingMobileTop?: string;
    paddingMobileBottom?: string;
    paddingMobileLeft?: string;
    paddingMobileRight?: string;
    marginDesktopTop?: string;
    marginDesktopBottom?: string;
    marginDesktopLeft?: string;
    marginDesktopRight?: string;
    marginMobileTop?: string;
    marginMobileBottom?: string;
    marginMobileLeft?: string;
    marginMobileRight?: string;
    removeStyling?: boolean;
    defaultPath?: string;
}

interface IVariantProps {
    ctaType?: 'ghosted-light' | 'ghosted-dark' | 'link' | 'chip' | 'solid';
    ctaSize?: 'small' | 'medium' | 'large';
    ctaIcon?: 'lock' | 'chevron' | 'back' | '';
    mobile?: boolean;
    variant?: string;
    text?: string;
    cta?: string;
    ctaId?: string;
    link?: string;
    videoLink?: string;
    params?: string;
    leftJustified?: boolean;
    centerJustified?: boolean;
    linkOpenNewTab?: boolean;
    hiddenOnMobile?: boolean;
    hiddenOnDesktop?: boolean;
    backgroundColor?: string;
    paddingDesktopTop?: string;
    paddingDesktopBottom?: string;
    paddingDesktopLeft?: string;
    paddingDesktopRight?: string;
    paddingMobileTop?: string;
    paddingMobileBottom?: string;
    paddingMobileLeft?: string;
    paddingMobileRight?: string;
    marginDesktopTop?: string;
    marginDesktopBottom?: string;
    marginDesktopLeft?: string;
    marginDesktopRight?: string;
    marginMobileTop?: string;
    marginMobileBottom?: string;
    marginMobileLeft?: string;
    marginMobileRight?: string;
    removeStyling?: boolean;
    defaultPath?: string;
}

export const CTATextEditConfig = {
    emptyLabel: 'Button',
    isEmpty: (props: PropsWithChildren<ICTATextProps>) => {
        return !props || !props.text;
    },
};

const CTAFirstVariant = (props: IVariantProps): JSX.Element => {
    const target: '_blank' | '_self' | undefined = (props.linkOpenNewTab) ? '_blank' : undefined;
    const { ctaSize = 'small' } = props;
    const { ctaIcon = '' } = props;
    const ctaUrl = window.location.href.includes('/deposits') ?
        retrieveDBOsgiUrl(props.link) : props.link;

    return (
        <div className='CTAText__stacked'>
            {props.cta && props.link && (
                <ButtonWrapper className={`CTAText__stackedButton${props.removeStyling ? '--removeStyling' : ''}`}
                    icon={ctaIcon === '' ? undefined: ctaIcon}
                    variant={props.ctaType}
                    size={ctaSize}
                    target={target}
                    href={ctaUrl ?? '#' + props.params ?? ''}
                    id={props.ctaId}>
                    <div>
                        {transformHTMLParserLinks(props.cta)}
                    </div>
                </ButtonWrapper>
            )}

            {props.text && (
                <div className='CTAText__text--center'>
                    {transformHTMLParserLinks(props.text)}
                </div>
            )}
        </div>
    );
};

const SideVariant = (props: IVariantProps): JSX.Element => {
    const target: '_blank' | '_self' | undefined = (props.linkOpenNewTab) ? '_blank' : undefined;
    const { ctaSize = 'small' } = props;
    const { ctaIcon = '' } = props;

    return (
        <Row className='CTAText__row'>
            {props.text && (
                <Col sm={9} className={`CTAText__col CTAText__text${(props.mobile) ? '--center' : ''}`}>
                    {transformHTMLParserLinks(props.text)}
                </Col>
            )}

            {props.cta && props.link && (
                <Col xs={12} sm={3} className={`CTAText__col CTAText__button${(props.mobile) ? '--center' : ''}`}>
                    <ButtonWrapper
                        icon={ctaIcon === '' ? undefined: ctaIcon}
                        variant={props.ctaType}
                        className={`CTAText__sideButton${props.removeStyling ? '--removeStyling' : ''} 
                        ${props.mobile ? 'CTAText__button--fill' : 'CTAText__button--right'}`}
                        target={target}
                        href={props.link ?? '#' + props.params ?? ''}
                        size={ctaSize}
                        id={props.ctaId}>
                        <div>
                            {transformHTMLParserLinks(props.cta)}
                        </div>
                    </ButtonWrapper>
                </Col>
            )}
        </Row>
    );
};

const SpeedbumpPageVariant = (props: IVariantProps): JSX.Element => {
    const target: '_blank' | '_self' | undefined = (props.linkOpenNewTab) ? '_blank' : undefined;
    const { ctaSize = 'small' } = props;
    const { ctaIcon = '' } = props;

    return (
        <Row className='CTAText__row'>
            {props.text && (
                <Col sm={9} className={`CTAText__col CTAText__text${(props.mobile) ? '--center' : ''}`}>
                    {transformHTMLParserLinks(props.text)}
                </Col>
            )}

            
            <Col xs={12} sm={3} className={`CTAText__col CTAText__button${(props.mobile) ? '--center' : ''}`}>
                <ButtonWrapper
                    icon={ctaIcon === '' ? undefined: ctaIcon}
                    variant={props.ctaType}
                    className={`CTAText__sideButton${props.removeStyling ? '--removeStyling' : ''} 
                    ${props.mobile ? 'CTAText__button--fill' : 'CTAText__button--right'}`}
                    target={target}
                    href={buildInsuranceRedirectURL(props.link, props.defaultPath)}
                    size={ctaSize}
                    id={props.ctaId}>
                    <div>
                        {transformHTMLParserLinks(props.cta)}
                    </div>
                </ButtonWrapper>
            </Col>
            
        </Row>
    );
};

const VideoPopupVariant = (props: IVariantProps): JSX.Element => {
    const target: '_blank' | '_self' | undefined = (props.linkOpenNewTab) ? '_blank' : undefined;
    const { ctaSize = 'small' } = props;
    const { ctaIcon = '' } = props;
    const [isOpen, setOpen] = useState(false);

    let idLink = props.videoLink;

    const parseLink = () => {
        const lastIndex = idLink.lastIndexOf('/');
        idLink = idLink.substring(lastIndex, idLink.length-1);
        idLink = idLink.replace(/[^a-zA-Z0-9 ]/g, '');
        idLink = idLink.replace(/\s+/g, '-');
        return idLink;
    };

    useEffect(() => {
        if (isOpen) {
            document.body.style.overflow = 'hidden';
        } else {
            document.body.style.overflow = 'auto';
        }
    }, [isOpen]);

    return (
        <>
            <Row className='CTAText__row'>
                {props.text && (
                    <Col sm={9} className={`CTAText__col CTAText__text${(props.mobile) ? '--center' : ''}`}>
                        {transformHTMLParserLinks(props.text)}
                    </Col>
                )}
            
                {props.videoLink && 
                    <Col  className={`CTAText__col CTAText__button${(props.mobile || props.centerJustified) ? '--center' : ''}`}>
                        <ButtonWrapper
                            icon={ctaIcon === '' ? undefined: ctaIcon}
                            variant={props.ctaType}
                            className={`CTAText__sideButton${props.removeStyling ? '--removeStyling' : ''} 
                            ${props.mobile ? 'CTAText__button--fill' : 'CTAText__button--right'}`}
                            target={target}
                            size={ctaSize}
                            id={props.ctaId}
                            onClick={() => {
                                setOpen(!isOpen); 
                            }}
                        >
                            <div>
                                {transformHTMLParserLinks(props.cta)}
                            </div>
                        </ButtonWrapper>
                    </Col>
                }
            </Row>

            {props.videoLink && 
                <Modal isOpen={isOpen} modalOpen={setOpen} className='CTAText__videoModal'>
                    <Video title='videoIframe' youtubeEmbedURL={props.videoLink}
                        id={'c1b-video-' + parseLink()} 
                        allow='accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share; fullscreen'
                        referrerPolicy='strict-origin-when-cross-origin'
                        videoDisclaimer={<p className='ytdisclaimer'>Credit One Bank uses YouTube API services and by watching the video, you are agreeing to the YouTube Terms of Service (<LinkWrapper target={'_self'} href='https://youtube.com/terms'>https://youtube.com/terms</LinkWrapper>) and Google Privacy Policy (<LinkWrapper target={'_self'} href='https://www.google.com/policies/privacy'>https://www.google.com/policies/privacy</LinkWrapper>).</p>}
                    />
                </Modal>
            }
        </>
    );
};

function buildInsuranceRedirectURL(url: string, defaultPath: string) {
    /*
        The expected outcome of this is the pathway and parameters 
        that are appended to the authored URL for the insurance website
    */
    const params = new URLSearchParams(window.location.search);
    const extractedParams = params.get('rd');
    const insuranceURL = url + (extractedParams ? extractedParams : defaultPath);
    return insuranceURL;
}

const Button = (props: PropsWithChildren<ICTATextProps>): JSX.Element => {
    const { width } = useWidthContext();
    const isMobile = width <= 768;
    const padding = {
        paddingTop: isMobile ? props.paddingMobileTop : props.paddingDesktopTop,
        paddingLeft: isMobile ? props.paddingMobileLeft : props.paddingDesktopLeft,
        paddingRight: isMobile ? props.paddingMobileRight : props.paddingDesktopRight,
        paddingBottom: isMobile ? props.paddingMobileBottom : props.paddingDesktopBottom,
    };

    const margin = {
        marginTop: isMobile ? props.marginMobileTop : props.marginDesktopTop,
        marginLeft: isMobile ? props.marginMobileLeft : props.marginDesktopLeft,
        marginRight: isMobile ? props.marginMobileRight : props.marginDesktopRight,
        marginBottom: isMobile ? props.marginMobileBottom : props.marginDesktopBottom,
    };

    if ((props.hiddenOnMobile && !props.isInEditor && (width <= 768)) ||
        (props.hiddenOnDesktop && !props.isInEditor && (width > 768))) {
        return (<div/>);
    }

    return (
        <div id='button' className={props.leftJustified ? 'CTAText--leftJustified' : 'CTAText' }>
            <Container fluid={true} className={(props.leftJustified ? 'CTAText__container--leftJustified' : 'CTAText__container') + ` CTAText__${props.backgroundColor}`} style={{ ...padding, ...margin }}>
                {(!props.variant || props.variant === 'side') && (
                    <SideVariant mobile={(width <= 768)} {...props} />
                )}

                {(props.variant === 'cta-first') && (
                    <CTAFirstVariant mobile={(width <= 768)} {...props} />
                )}

                {(props.variant === 'speedbumpPageFirst') && (
                    <SpeedbumpPageVariant mobile={(width <= 768)} {...props} />
                )}

                {(props.variant === 'videoPopup') && (
                    <VideoPopupVariant mobile={(width <= 768)} {...props} />
                )}
            </Container>
        </div>
    );
};

export default Button;